/** Reader safety copy: reporting, blocking, the Terms entry gate and restrictions. */
export const communityCopy = {
  en: {
    readerFallback: 'this reader',
    menu: {
      labelAuthored: 'More options for {{name}}’s post',
      labelLine: 'More options for this quote',
      report: {
        review: 'Report review',
        thought: 'Report thought',
        line: 'Report quote',
      },
      reportReader: 'Report reader',
      blockReader: 'Block reader',
    },
    block: {
      title: 'Block {{name}}?',
      body: 'You won’t see their reviews or thoughts anywhere in Belore. They won’t be notified. You can unblock them in Profile → Blocked readers.',
      confirm: 'Block',
      done: '{{name}} is blocked. You won’t see their reviews or thoughts.',
      error: 'This reader could not be blocked. Try again.',
    },
    report: {
      titleReader: 'Report {{name}}',
      introContent:
        'Tell us what’s wrong. Our moderators review every report. You won’t see this post again once you send the report.',
      introReader:
        'This reports {{name}}’s profile: their name, nickname or photo. To report one post, choose Report review or Report thought instead.',
      reason: 'Reason',
      reasons: {
        spam: 'Spam or advertising',
        harassment: 'Harassment or hate',
        sexual_or_violent: 'Sexual or violent content',
        spoilers: 'Spoilers without a warning',
        other: 'Something else',
      },
      note: 'Note for the moderators (optional)',
      notePlaceholder: 'Anything that helps us understand the problem',
      policy:
        'Reports are confidential: the reader isn’t told who reported them. Moderators remove posts that break the community guidelines.',
      send: 'Send report',
      sentTitle: 'Thanks for your report',
      sent: {
        hidden: {
          review: 'You won’t see this review again',
          thought: 'You won’t see this thought again',
          line: 'You won’t see this quote again',
        },
        hiddenDetail: 'On any of your devices.',
        moderators: {
          review: 'Our moderators will look at it',
          thought: 'Our moderators will look at it',
          line: 'Our moderators will look at it',
        },
        moderatorsReader: 'Our moderators will look at {{name}}’s profile',
        moderatorsDetail: 'If it breaks the community guidelines, they’ll act on it.',
        confidential: 'Your report is confidential',
        confidentialDetail: 'No one is told who sent it.',
        nextLabel: 'Want to go further?',
        blockBody:
          'Block them and you won’t see their reviews or thoughts anywhere in Belore. They won’t be told.',
        blocked: 'Blocked. You can unblock them in Profile.',
      },
      duplicate: 'You’ve already reported this. Our moderators will look at it.',
      done: 'Done',
      rateLimited: 'You’ve sent several reports recently. Wait a while before sending another.',
      unavailable: 'This is no longer available to report.',
      error: 'Your report could not be sent. Try again.',
    },
    blocked: {
      title: 'Blocked readers',
      intro:
        'You don’t see blocked readers’ reviews or thoughts anywhere in Belore. They aren’t told that you blocked them.',
      empty: 'You haven’t blocked anyone.',
      since: 'Blocked {{date}}',
      unblock: 'Unblock',
      unblockLabel: 'Unblock {{name}}',
      loadError: 'Blocked readers could not be loaded.',
      unblockError: 'This reader could not be unblocked. Try again.',
    },
    terms: {
      eyebrow: 'BEFORE YOU CONTINUE',
      title: 'Community guidelines',
      updatedEyebrow: 'TERMS UPDATED',
      updatedTitle: 'Our Terms have changed',
      gateIntro: 'To keep using Belore, accept the Terms of Use and community guidelines.',
      intro:
        'Belore is a community of readers. Your reviews and thoughts can be public, so a few rules apply to everyone:',
      rule1: 'No spam, advertising or links to sell things.',
      rule2: 'No harassment, hate or threats.',
      rule3: 'No sexual or violent content.',
      rule4: 'Mark spoilers before you post them.',
      moderation:
        'Moderators review public posts and reports. Posts that break the guidelines are removed, and repeated breaches can stop you posting publicly.',
      links:
        'Read the <terms>Community guidelines and Terms of Use</terms> and the <privacy>Privacy policy</privacy>.',
      consent: 'I agree to the Terms of Use and community guidelines',
      accept: 'Accept and continue',
      declineNote: 'If you don’t agree, you can’t use Belore with this account.',
      signOut: 'Sign out',
      acceptError: 'Your acceptance could not be saved. Check your connection and try again.',
    },
    restricted: {
      note: 'Public posting isn’t available for your account right now. You can still save privately.',
      noteUntil:
        'Public posting isn’t available for your account until {{date}}. You can still save privately.',
    },
    errors: {
      termsRequired:
        'Public posting needs the updated Terms of Use. Save it privately for now; Belore will ask you to accept them when you next open it.',
      restricted:
        'Public posting isn’t available for your account right now. Save it privately instead.',
    },
  },
  sk: {
    readerFallback: 'tento čitateľ',
    menu: {
      labelAuthored: 'Ďalšie možnosti príspevku: {{name}}',
      labelLine: 'Ďalšie možnosti tohto citátu',
      report: {
        review: 'Nahlásiť recenziu',
        thought: 'Nahlásiť myšlienku',
        line: 'Nahlásiť citát',
      },
      reportReader: 'Nahlásiť čitateľa',
      blockReader: 'Zablokovať čitateľa',
    },
    block: {
      title: 'Zablokovať: {{name}}?',
      body: 'Jeho recenzie ani myšlienky už v Belore nikde neuvidíš. Nedostane o tom žiadne upozornenie. Odblokovať ho môžeš v Profile → Zablokovaní čitatelia.',
      confirm: 'Zablokovať',
      done: '{{name}} je zablokovaný. Jeho recenzie ani myšlienky už neuvidíš.',
      error: 'Čitateľa sa nepodarilo zablokovať. Skús to znova.',
    },
    report: {
      titleReader: 'Nahlásiť: {{name}}',
      introContent:
        'Povedz nám, čo nie je v poriadku. Každé nahlásenie posúdia naši moderátori. Po odoslaní tento príspevok už neuvidíš.',
      introReader:
        'Nahlasuješ profil čitateľa {{name}}: jeho meno, prezývku alebo fotku. Ak chceš nahlásiť jeden príspevok, vyber Nahlásiť recenziu alebo Nahlásiť myšlienku.',
      reason: 'Dôvod',
      reasons: {
        spam: 'Spam alebo reklama',
        harassment: 'Obťažovanie alebo nenávisť',
        sexual_or_violent: 'Sexuálny alebo násilný obsah',
        spoilers: 'Spoilery bez upozornenia',
        other: 'Niečo iné',
      },
      note: 'Poznámka pre moderátorov (nepovinné)',
      notePlaceholder: 'Čokoľvek, čo nám pomôže pochopiť problém',
      policy:
        'Nahlásenia sú dôverné: čitateľ sa nedozvie, kto ho nahlásil. Moderátori odstraňujú príspevky, ktoré porušujú pravidlá komunity.',
      send: 'Odoslať nahlásenie',
      sentTitle: 'Ďakujeme za nahlásenie',
      sent: {
        hidden: {
          review: 'Túto recenziu už neuvidíš',
          thought: 'Túto myšlienku už neuvidíš',
          line: 'Tento citát už neuvidíš',
        },
        hiddenDetail: 'Na žiadnom zo svojich zariadení.',
        moderators: {
          review: 'Pozrú sa na ňu moderátori',
          thought: 'Pozrú sa na ňu moderátori',
          line: 'Pozrú sa naň moderátori',
        },
        moderatorsReader: 'Moderátori posúdia profil čitateľa {{name}}',
        moderatorsDetail: 'Ak porušuje pravidlá komunity, zakročia.',
        confidential: 'Nahlásenie je dôverné',
        confidentialDetail: 'Nikto sa nedozvie, kto ho poslal.',
        nextLabel: 'Chceš ísť ďalej?',
        blockBody:
          'Zablokuj ho a jeho recenzie ani myšlienky už v Belore nikde neuvidíš. Nedozvie sa to.',
        blocked: 'Zablokovaný. Odblokovať ho môžeš v Profile.',
      },
      duplicate: 'Toto si už nahlásil. Naši moderátori sa na to pozrú.',
      done: 'Hotovo',
      rateLimited:
        'V poslednom čase si poslal viacero nahlásení. Chvíľu počkaj, kým pošleš ďalšie.',
      unavailable: 'Toto už nie je možné nahlásiť.',
      error: 'Nahlásenie sa nepodarilo odoslať. Skús to znova.',
    },
    blocked: {
      title: 'Zablokovaní čitatelia',
      intro:
        'Recenzie ani myšlienky zablokovaných čitateľov v Belore nikde nevidíš. Nedozvedia sa, že si ich zablokoval.',
      empty: 'Nikoho si nezablokoval.',
      since: 'Zablokovaný {{date}}',
      unblock: 'Odblokovať',
      unblockLabel: 'Odblokovať: {{name}}',
      loadError: 'Zablokovaných čitateľov sa nepodarilo načítať.',
      unblockError: 'Čitateľa sa nepodarilo odblokovať. Skús to znova.',
    },
    terms: {
      eyebrow: 'PRED POKRAČOVANÍM',
      title: 'Pravidlá komunity',
      updatedEyebrow: 'AKTUALIZOVANÉ PODMIENKY',
      updatedTitle: 'Naše podmienky sa zmenili',
      gateIntro:
        'Ak chceš Belore používať aj naďalej, prijmi podmienky používania a pravidlá komunity.',
      intro:
        'Belore je komunita čitateľov. Tvoje recenzie a myšlienky môžu byť verejné, preto pre všetkých platí pár pravidiel:',
      rule1: 'Žiadny spam, reklama ani odkazy na predaj.',
      rule2: 'Žiadne obťažovanie, nenávisť ani vyhrážky.',
      rule3: 'Žiadny sexuálny ani násilný obsah.',
      rule4: 'Spoilery pred zverejnením označ.',
      moderation:
        'Moderátori kontrolujú verejné príspevky aj nahlásenia. Príspevky, ktoré porušujú pravidlá, odstránia a pri opakovanom porušení ti môžu verejné príspevky obmedziť.',
      links:
        'Prečítaj si <terms>Pravidlá komunity a podmienky používania</terms> a <privacy>Zásady ochrany súkromia</privacy>.',
      consent: 'Súhlasím s podmienkami používania a pravidlami komunity',
      accept: 'Prijať a pokračovať',
      declineNote: 'Bez súhlasu nemôžeš Belore s týmto účtom používať.',
      signOut: 'Odhlásiť sa',
      acceptError: 'Súhlas sa nepodarilo uložiť. Skontroluj pripojenie a skús to znova.',
    },
    restricted: {
      note: 'Verejné príspevky teraz nie sú pre tvoj účet dostupné. Stále môžeš ukladať súkromne.',
      noteUntil:
        'Verejné príspevky nie sú pre tvoj účet dostupné do {{date}}. Stále môžeš ukladať súkromne.',
    },
    errors: {
      termsRequired:
        'Na verejné príspevky treba prijať aktualizované podmienky používania. Zatiaľ to ulož súkromne – pri ďalšom otvorení ťa Belore požiada o súhlas.',
      restricted: 'Verejné príspevky teraz nie sú pre tvoj účet dostupné. Ulož ho súkromne.',
    },
  },
  cs: {
    readerFallback: 'tento čtenář',
    menu: {
      labelAuthored: 'Další možnosti příspěvku: {{name}}',
      labelLine: 'Další možnosti tohoto citátu',
      report: {
        review: 'Nahlásit recenzi',
        thought: 'Nahlásit myšlenku',
        line: 'Nahlásit citát',
      },
      reportReader: 'Nahlásit čtenáře',
      blockReader: 'Zablokovat čtenáře',
    },
    block: {
      title: 'Zablokovat: {{name}}?',
      body: 'Jeho recenze ani myšlenky už v Belore nikde neuvidíš. Nedostane o tom žádné upozornění. Odblokovat ho můžeš v Profilu → Zablokovaní čtenáři.',
      confirm: 'Zablokovat',
      done: '{{name}} je zablokovaný. Jeho recenze ani myšlenky už neuvidíš.',
      error: 'Čtenáře se nepodařilo zablokovat. Zkus to znovu.',
    },
    report: {
      titleReader: 'Nahlásit: {{name}}',
      introContent:
        'Řekni nám, co není v pořádku. Každé nahlášení posoudí naši moderátoři. Po odeslání tento příspěvek už neuvidíš.',
      introReader:
        'Nahlašuješ profil čtenáře {{name}}: jeho jméno, přezdívku nebo fotku. Pokud chceš nahlásit jeden příspěvek, vyber Nahlásit recenzi nebo Nahlásit myšlenku.',
      reason: 'Důvod',
      reasons: {
        spam: 'Spam nebo reklama',
        harassment: 'Obtěžování nebo nenávist',
        sexual_or_violent: 'Sexuální nebo násilný obsah',
        spoilers: 'Spoilery bez upozornění',
        other: 'Něco jiného',
      },
      note: 'Poznámka pro moderátory (nepovinné)',
      notePlaceholder: 'Cokoli, co nám pomůže pochopit problém',
      policy:
        'Nahlášení jsou důvěrná: čtenář se nedozví, kdo ho nahlásil. Moderátoři odstraňují příspěvky, které porušují pravidla komunity.',
      send: 'Odeslat nahlášení',
      sentTitle: 'Děkujeme za nahlášení',
      sent: {
        hidden: {
          review: 'Tuto recenzi už neuvidíš',
          thought: 'Tuto myšlenku už neuvidíš',
          line: 'Tento citát už neuvidíš',
        },
        hiddenDetail: 'Na žádném ze svých zařízení.',
        moderators: {
          review: 'Podívají se na ni moderátoři',
          thought: 'Podívají se na ni moderátoři',
          line: 'Podívají se na něj moderátoři',
        },
        moderatorsReader: 'Moderátoři posoudí profil čtenáře {{name}}',
        moderatorsDetail: 'Pokud porušuje pravidla komunity, zakročí.',
        confidential: 'Nahlášení je důvěrné',
        confidentialDetail: 'Nikdo se nedozví, kdo ho poslal.',
        nextLabel: 'Chceš jít dál?',
        blockBody:
          'Zablokuj ho a jeho recenze ani myšlenky už v Belore nikde neuvidíš. Nedozví se to.',
        blocked: 'Zablokován. Odblokovat ho můžeš v Profilu.',
      },
      duplicate: 'Tohle už jsi nahlásil. Naši moderátoři se na to podívají.',
      done: 'Hotovo',
      rateLimited: 'V poslední době jsi poslal několik nahlášení. Chvíli počkej, než pošleš další.',
      unavailable: 'Tohle už není možné nahlásit.',
      error: 'Nahlášení se nepodařilo odeslat. Zkus to znovu.',
    },
    blocked: {
      title: 'Zablokovaní čtenáři',
      intro:
        'Recenze ani myšlenky zablokovaných čtenářů v Belore nikde nevidíš. Nedozví se, že jsi je zablokoval.',
      empty: 'Nikoho jsi nezablokoval.',
      since: 'Zablokován {{date}}',
      unblock: 'Odblokovat',
      unblockLabel: 'Odblokovat: {{name}}',
      loadError: 'Zablokované čtenáře se nepodařilo načíst.',
      unblockError: 'Čtenáře se nepodařilo odblokovat. Zkus to znovu.',
    },
    terms: {
      eyebrow: 'PŘED POKRAČOVÁNÍM',
      title: 'Pravidla komunity',
      updatedEyebrow: 'AKTUALIZOVANÉ PODMÍNKY',
      updatedTitle: 'Naše podmínky se změnily',
      gateIntro:
        'Pokud chceš Belore používat i nadále, přijmi podmínky používání a pravidla komunity.',
      intro:
        'Belore je komunita čtenářů. Tvoje recenze a myšlenky můžou být veřejné, proto pro všechny platí pár pravidel:',
      rule1: 'Žádný spam, reklama ani odkazy na prodej.',
      rule2: 'Žádné obtěžování, nenávist ani výhrůžky.',
      rule3: 'Žádný sexuální ani násilný obsah.',
      rule4: 'Spoilery před zveřejněním označ.',
      moderation:
        'Moderátoři kontrolují veřejné příspěvky i nahlášení. Příspěvky, které porušují pravidla, odstraní a při opakovaném porušení ti mohou veřejné příspěvky omezit.',
      links:
        'Přečti si <terms>Pravidla komunity a podmínky používání</terms> a <privacy>Zásady ochrany soukromí</privacy>.',
      consent: 'Souhlasím s podmínkami používání a pravidly komunity',
      accept: 'Přijmout a pokračovat',
      declineNote: 'Bez souhlasu nemůžeš Belore s tímto účtem používat.',
      signOut: 'Odhlásit se',
      acceptError: 'Souhlas se nepodařilo uložit. Zkontroluj připojení a zkus to znovu.',
    },
    restricted: {
      note: 'Veřejné příspěvky teď pro tvůj účet nejsou dostupné. Stále můžeš ukládat soukromě.',
      noteUntil:
        'Veřejné příspěvky pro tvůj účet nejsou dostupné do {{date}}. Stále můžeš ukládat soukromě.',
    },
    errors: {
      termsRequired:
        'Pro veřejné příspěvky je potřeba přijmout aktualizované podmínky používání. Zatím to ulož soukromě – při dalším otevření tě Belore požádá o souhlas.',
      restricted: 'Veřejné příspěvky teď pro tvůj účet nejsou dostupné. Ulož ho soukromě.',
    },
  },
} as const;
